import React, { useState } from 'react';
import styled from 'styled-components';
import { FaFacebookF, FaApple, FaGoogle } from 'react-icons/fa';
import { SiKakao } from 'react-icons/si';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAccessToken, useUserInfoQuery } from '../react-queries/queries';

const Wrapper = styled.div`
  min-height: 100vh;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
`;

const Box = styled.div`
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 20px 32px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 8px;
  line-height: 1.4;
`;

const SubTitle = styled.div`
  color: #888;
  font-size: 1rem;
  text-align: center;
  margin-bottom: 32px;
`;

const Input = styled.input`
  width: 100%;
  padding: 14px 12px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 16px;
  background: #fafafa;
`;

const NoobookButton = styled.button`
  width: 100%;
  padding: 14px 0;
  background: #bdbdbd;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 18px;
  cursor: pointer;
`;

const Or = styled.div`
  text-align: center;
  color: #bbb;
  margin: 10px 0 18px 0;
  font-size: 0.95rem;
`;

interface SnsButtonProps {
  snsType: 'kakao' | 'google';
}

const SnsButton = styled.button<SnsButtonProps>`
  width: 100%;
  padding: 14px 0;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  background: ${({ snsType }) =>
    snsType === 'kakao' ? '#FEE500' :
    snsType === 'google' ? '#fff' : '#fff'};
  color: ${({ snsType }) =>
    snsType === 'kakao' ? '#3C1E1E' :
    snsType === 'google' ? '#222' : '#000'};
  border: ${({ snsType }) =>
    snsType === 'google' ? '1px solid #ddd' : 'none'};
`;

const clientId = "5e9623791b63ebfa0540ce6d4e4de91e";
const redirectUrlHost = window.location.protocol + '//' + window.location.host;
const kakaoRedirectUrl = redirectUrlHost + '/login/kakao';

const handleKakaoLogin = () => {
  window.location.href = `https://kauth.kakao.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${kakaoRedirectUrl}`;
};

const LoginPage: React.FC<{isWebview: boolean}> = ({isWebview}) => {
  const navigate = useNavigate();
  const { refetch: refetchUserInfo } = useUserInfoQuery();


  React.useEffect(() => {
    getAccessToken().then(({accessToken, refreshToken}) => {
      if (accessToken && refreshToken) {
        refetchUserInfo();
        navigate('/home', { replace: true });
      }
    });
  }, [isWebview, navigate]);

  const handleNoobookClick = () => {
    navigate('/login/form', { replace: true });
  };

  return (
    <Wrapper>
      <Box>
        <Title>
          독서인을 위한<br />
          지적 경험 플랫폼, 누북!
        </Title>
        <SubTitle>
          독서와 필사 그리고 모임까지<br />
          독서인에 의한, 독서인을 위한 기록+소통, 누북으로 시작하세요!
        </SubTitle>
        <NoobookButton onClick={handleNoobookClick}>누북으로 시작하기</NoobookButton>
        <Or>or</Or>
        <SnsButton snsType="kakao" onClick={handleKakaoLogin}>
          카카오로 시작하기
        </SnsButton>
        <SnsButton snsType="google">
          Google로 시작하기
        </SnsButton>
      </Box>
    </Wrapper>
  );
};

export default LoginPage; 